var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "q-form",
    { ref: "editForm" },
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-2" },
          [
            _c(
              "c-card",
              {
                staticClass: "cardClassDetailForm",
                attrs: { title: "점검설비 상세" },
              },
              [
                _c(
                  "template",
                  { slot: "card-button" },
                  [
                    _c(
                      "q-btn-group",
                      { attrs: { outline: "" } },
                      [
                        _c("c-btn", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.editInfo &&
                                _vm.preStartupCheck.sopPrestartupCheckId &&
                                !_vm.disabled,
                              expression:
                                "editInfo&&preStartupCheck.sopPrestartupCheckId&&!disabled",
                            },
                          ],
                          attrs: {
                            isSubmit: _vm.isComplete,
                            url: _vm.completeUrl,
                            param: _vm.preStartupEquipment,
                            mappingType: "PUT",
                            label: "완료",
                            icon: "check",
                          },
                          on: {
                            beforeAction: _vm.completePreStartupEquipment,
                            btnCallback: _vm.completeCallback,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("template", { slot: "card-detail" }, [
                  _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-2 col-md-2 col-lg-12" },
                    [
                      _c("c-text", {
                        attrs: {
                          editable: _vm.editInfo,
                          disabled: true,
                          label: "설비유형",
                          name: "equipmentTypeName",
                        },
                        model: {
                          value: _vm.preStartupEquipment.equipmentTypeName,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.preStartupEquipment,
                              "equipmentTypeName",
                              $$v
                            )
                          },
                          expression: "preStartupEquipment.equipmentTypeName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-4 col-md-4 col-lg-12" },
                    [
                      _c("c-multi-select", {
                        attrs: {
                          editable: _vm.editInfo,
                          disabled: _vm.disabled,
                          isObject: true,
                          disabledItems: _vm.disabledItems,
                          codeGroupCd: "PSR_CHECK_TYPE_CD",
                          itemText: "codeName",
                          itemValue: "code",
                          valueText: "psrCheckTypeName",
                          valueKey: "psrCheckTypeCd",
                          label: "점검유형",
                          name: "checkTypes",
                        },
                        on: { datachange: _vm.changeCheckType },
                        model: {
                          value: _vm.preStartupEquipment.checkTypes,
                          callback: function ($$v) {
                            _vm.$set(_vm.preStartupEquipment, "checkTypes", $$v)
                          },
                          expression: "preStartupEquipment.checkTypes",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-2 col-md-2 col-lg-12" },
                    [
                      _c("c-field", {
                        attrs: {
                          required: true,
                          editable: _vm.editInfo,
                          disabled: _vm.disabled,
                          type: "user",
                          label: "설비점검책임자",
                          name: "checkUserId",
                        },
                        model: {
                          value: _vm.preStartupEquipment.checkUserId,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.preStartupEquipment,
                              "checkUserId",
                              $$v
                            )
                          },
                          expression: "preStartupEquipment.checkUserId",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-2 col-md-2 col-lg-12" },
                    [
                      _c("c-datepicker", {
                        attrs: {
                          editable: _vm.editInfo,
                          disabled: _vm.disabled,
                          label: "점검예정일",
                          name: "checkScheduleDate",
                        },
                        model: {
                          value: _vm.preStartupEquipment.checkScheduleDate,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.preStartupEquipment,
                              "checkScheduleDate",
                              $$v
                            )
                          },
                          expression: "preStartupEquipment.checkScheduleDate",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-2 col-md-2 col-lg-12" },
                    [
                      _c("c-datepicker", {
                        attrs: {
                          editable: _vm.editInfo,
                          disabled: _vm.disabled,
                          label: "점검일",
                          name: "checkDate",
                        },
                        model: {
                          value: _vm.preStartupEquipment.checkDate,
                          callback: function ($$v) {
                            _vm.$set(_vm.preStartupEquipment, "checkDate", $$v)
                          },
                          expression: "preStartupEquipment.checkDate",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12" },
                    [
                      _c("c-textarea", {
                        attrs: {
                          editable: _vm.editInfo,
                          disabled: _vm.disabled,
                          rows: 5,
                          label: "점검결과종합",
                          name: "checkResultTotal",
                        },
                        model: {
                          value: _vm.preStartupEquipment.checkResultTotal,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.preStartupEquipment,
                              "checkResultTotal",
                              $$v
                            )
                          },
                          expression: "preStartupEquipment.checkResultTotal",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ],
              2
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-10" },
          [
            _c("c-table", {
              ref: "table",
              attrs: {
                title: "점검결과 목록",
                columns: _vm.grid.columns,
                gridHeight: _vm.grid.height,
                data: _vm.preStartupEquipment.checkItems,
                merge: _vm.grid.merge,
                filtering: false,
                columnSetting: false,
                usePaging: false,
                editable: _vm.editInfo && !_vm.disabled,
              },
              scopedSlots: _vm._u([
                {
                  key: "customArea",
                  fn: function ({ props, col }) {
                    return [
                      _c(
                        "div",
                        { staticStyle: { "padding-top": "15px" } },
                        [
                          _vm._l(props.row.improves, function (item, index) {
                            return _c(
                              "q-chip",
                              {
                                key: index,
                                staticStyle: {
                                  "margin-bottom": "4px !important",
                                },
                                attrs: {
                                  color: item.stepColorClass || "red-6",
                                  clickable: true,
                                  "text-color": "white",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.openImprove(props, col, item)
                                  },
                                },
                              },
                              [
                                item.ibmClassCd === "IC00000001"
                                  ? [
                                      _vm._v(
                                        " " +
                                          _vm._s(item.sopImprovementId) +
                                          " / " +
                                          _vm._s(item.ibmStepName) +
                                          " "
                                      ),
                                    ]
                                  : [
                                      _vm._v(
                                        " " +
                                          _vm._s(item.sopImprovementId) +
                                          " / 즉시조치 "
                                      ),
                                    ],
                              ],
                              2
                            )
                          }),
                          props.row.editFlag !== "C"
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "q-btn-group",
                                    {
                                      staticClass: "ColumInnerBtnGroup",
                                      attrs: { outline: "" },
                                    },
                                    [
                                      _vm.editInfo && !_vm.disabled
                                        ? _c(
                                            "q-btn",
                                            {
                                              staticClass: "ColumInnerBtn",
                                              attrs: {
                                                icon: "add",
                                                color: "blue-6",
                                                "text-color": "white",
                                                align: "center",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.preventDefault()
                                                  return _vm.innerBtnClicked(
                                                    col,
                                                    props
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("q-tooltip", [
                                                _vm._v(" 개선요청등록 "),
                                              ]),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        2
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ]),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }